import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import BrandAiChat from "./components/feature/BrandAiChat";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import SiteLocaleTranslator from "./components/feature/SiteLocaleTranslator";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <SiteLocaleTranslator />
        <AppRoutes />
        <a
          href="https://www.instagram.com/unboundedoriginal"
          target="_blank"
          rel="nofollow noopener noreferrer"
          aria-label="未境原創 Instagram"
          className="fixed bottom-6 right-6 z-50 flex h-12 w-12 items-center justify-center rounded-full bg-accent-500 text-background-50 shadow-lg transition-transform hover:scale-110 hover:bg-accent-600 cursor-pointer"
        >
          <i className="ri-instagram-line text-xl"></i>
        </a>
        <BrandAiChat brandName="未境原創" siteUrl="https://vijing.sonbook.net" />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
